/**
 * Proposals API client (Phase 32 — HITL review mode).
 *
 * All proposal routes live under /api/projects/{id}/proposals/{filename}.
 * The filename is a flat string (e.g. `6_account_plan.proposed.md`) so it
 * travels safely as a path param — no query-string encoding needed.
 */

import { request } from "./api.js";

/** Fetch a proposal with proposed + canonical markdown and section statuses. */
export const getProposal = (projectId, filename) =>
  request(`/api/projects/${projectId}/proposals/${encodeURIComponent(filename)}`);

/** Accept a single section. */
export const acceptSection = (projectId, filename, sectionId) =>
  request(
    `/api/projects/${projectId}/proposals/${encodeURIComponent(filename)}/sections/${encodeURIComponent(sectionId)}/accept`,
    { method: "POST" },
  );

/** Reject a single section, optionally with feedback for scoped regen. */
export const rejectSection = (projectId, filename, sectionId, feedback) =>
  request(
    `/api/projects/${projectId}/proposals/${encodeURIComponent(filename)}/sections/${encodeURIComponent(sectionId)}/reject`,
    {
      method: "POST",
      body: JSON.stringify({ feedback: feedback || undefined }),
    },
  );

/** Accept all remaining pending sections — triggers canonical merge. */
export const acceptAll = (projectId, filename) =>
  request(
    `/api/projects/${projectId}/proposals/${encodeURIComponent(filename)}/accept-all`,
    { method: "POST" },
  );

/** Reject all remaining pending sections — deletes proposed file. */
export const rejectAll = (projectId, filename) =>
  request(
    `/api/projects/${projectId}/proposals/${encodeURIComponent(filename)}/reject-all`,
    { method: "POST" },
  );
